<template>
	<div class="zonasur">
		<v-container  
				class="overflow-y-auto"
		>
			<v-layout row>
                
				<v-flex md9 xs12 class="pt-5 pa-4">
                    <v-flex xs12>
                        <h2>Sub sedes - zona sur</h2>
                    </v-flex>
					<v-container>
                        <v-row dense>
                            <v-col
                            v-for="(item, i) in items"
                            :key="i"
                            cols="12"
                            xs="12"
                            sm="6"
                            md="6"
                            >
                                <v-skeleton-loader
                                    :loading="loading"
                                    transition="scale-transition"
                                    height="94"
                                    type="list-item-two-line"
                                >
                                    <v-card
                                        :color="item.color"
                                        dark
                                    >
                                        <div class="d-flex flex-no-wrap justify-space-between">
                                            <div>
                                                <v-card-title
                                                class="headline"
                                                v-text="item.title"
                                                ></v-card-title>

                                                <v-card-subtitle v-text="item.subtitle"></v-card-subtitle>
                                                <v-card-subtitle v-text="item.direccion" class="pt-0"></v-card-subtitle>
                                            </div>

                                            <v-hover>
                                                <template v-slot:default="{ hover }">
                                                    <a :href="item.location"
                                                        target="_blank" class="text-decoration-none">
                                                        <v-avatar
                                                            class="ma-3"
                                                            size="125"
                                                            tile
                                                        >
                                                            <v-icon size="125">mdi-map-marker-outline</v-icon>
                                                            <v-fade-transition>
                                                                <v-overlay
                                                                    v-if="hover"
                                                                    absolute
                                                                    color="#036358"
                                                                >
                                                                    <v-btn color="transparent">Ver mapa</v-btn>
                                                                </v-overlay>
                                                            </v-fade-transition>
                                                        </v-avatar>
                                                    </a>
                                                </template>
                                            </v-hover>
                                        </div>
                                    </v-card>
                                </v-skeleton-loader>
                            </v-col>
                        </v-row>
                    </v-container>
				</v-flex>
				<v-flex md3 xs12>
					<Servicios />
				</v-flex>
			</v-layout>
		</v-container>
	</div>
</template>
<script>
  const Servicios = () => import('@/components/Servicios.vue')
	export default {
		components: {
			Servicios
		},
        data() {
            return {
                loading:false,
                items: [
                        {
                        color: '#1F7087',
                        title: 'Sede Central',
                        subtitle: 'PUNO - PUNO - PUNO',
                        direccion: 'Jr. Puno 459 - Plaza de Armas',
                        location:"https://www.google.com.pe/maps/place/15%C2%B050'27.2%22S+70%C2%B001'40.7%22W/@-15.8408907,-70.0285092,19z/data=!3m1!4b1!4m6!3m5!1s0x0:0x0!7e2!8m2!3d-15.8408921!4d-70.0279618",
                        },
                        {
                        color: '#1F7087',
                        title: 'Sede Acora',
                        subtitle: 'PUNO - PUNO - ACORA',
                        direccion: 'Centro Civico Municipio ',
                        location:"https://www.google.com.pe/maps/dir//Acora,+21511/@-15.9730163,-69.7958909,20z/data=!4m8!4m7!1m0!1m5!1m1!1s0x915d0c58c32269cd:0x593b2c53ceb110bb!2m2!1d-69.7955231!2d-15.9727363",
                        },
                        {
                        color: '#1F7087',
                        title: 'Sede Ilave',
                        subtitle: 'PUNO - EL COLLAO - ILAVE',
                        direccion: 'Jr. Puno Nº 224 ',
                        location:"https://www.google.com.pe/maps/dir//Pueb+Ilave,+Ilave+21501/@-16.086168,-69.6402255,19z/data=!4m8!4m7!1m0!1m5!1m1!1s0x915da7ded1e9d36d:0x5fd72210f86bf8ed!2m2!1d-69.6397573!2d-16.0863527"
                        },
                        {
                        color: '#1F7087',
                        title: 'Sede Juli',
                        subtitle: 'PUNO - CHUCUITO - JULI',
                        direccion: 'Jr. Lima N° 322 Esq. Yunguyo (Barrio San Bartolomé) ',
                        location: "https://www.google.com.pe/maps/dir//PODER+JUDICIAL+JULI,+Jir%C3%B3n+Lima+353-277,+Juli+21531/@-16.2134919,-69.4584749,19.85z/data=!4m8!4m7!1m0!1m5!1m1!1s0x915db38d12e5ca71:0x5af4baadd829c526!2m2!1d-69.4581826!2d-16.2133636"
                        },
                        {
                        color: '#1F7087',
                        title: 'Sede Desaguadero',
                        subtitle: 'PUNO - CHUCUITO - DESAGUADERO',
                        direccion: 'Avenida 28 De Julio 305',
                        location:"https://www.google.com/maps/dir//Municipalidad+Distrital+de+Desaguadero,+Avenida+28+De+Julio+305,+Desaguadero+21611/@-16.5639604,-69.0399146,17.28z/data=!4m8!4m7!1m0!1m5!1m1!1s0x915c2278425b8fcd:0xe8cefb9ea92d3a21!2m2!1d-69.0394323!2d-16.5643111"
                        },
                        {
                        color: '#1F7087',
                        title: 'Sede Yunguyo',
                        subtitle: 'PUNO - YUNGUYO - YUNGUYO',
                        direccion: 'Av Circunvalacion S/N 4° cuadra - Coropampa II ',
                        location:"https://www.google.com.pe/maps/dir//-16.249791,-69.0893459/@-16.2494392,-69.0896162,17.86z/data=!4m2!4m1!3e0"
                        },
                    ]
            }
        },
	}

</script>
